import 'svelte/internal/disclose-version';

App[$.FILENAME] = 'src/client/app.svelte';

import * as $ from 'svelte/internal/client';
import "./index.css";
import { onMount } from "svelte";
import { searchInstances, getInstanceCount } from "./meilisearch-client";

var root_1 = $.add_locations(
	$.from_html(
		`
      <p class="text-gray-400">Searching...</p>
    `,
		1
	),
	App[$.FILENAME],
	[[69, 6]]
);

var root_2 = $.add_locations(
	$.from_html(
		`
      <p class="text-red-400"> </p>
    `,
		1
	),
	App[$.FILENAME],
	[[71, 6]]
);

var root_4 = $.add_locations(
	$.from_html(
		`
        <p class="mb-4 text-sm font-medium text-liseran">Featured instances</p>
      `,
		1
	),
	App[$.FILENAME],
	[[74, 8]]
);

var root_5 = $.add_locations(
	$.from_html(
		`
          <li class="rounded-lg border border-mauve-800 bg-mauve-900/50 p-4">
            <a target="_blank" rel="noopener noreferrer" class="text-lg font-semibold text-liseran hover:underline"> </a>
            <p class="mt-1 text-sm text-gray-400"> </p>
          </li>
        `,
		1
	),
	App[$.FILENAME],
	[[78, 10, [[79, 12], [87, 12]]]]
);

var root_3 = $.add_locations(
	$.from_html(
		`
      <!>
      <ul class="space-y-4">
        <!>
      </ul>
    `,
		1
	),
	App[$.FILENAME],
	[[76, 6]]
);

var root_6 = $.add_locations(
	$.from_html(
		`
      <p class="text-gray-400">No results found.</p>
    `,
		1
	),
	App[$.FILENAME],
	[[92, 6]]
);

var root_7 = $.add_locations(
	$.from_html(
		`
      <p class="text-gray-400">No instances available.</p>
    `,
		1
	),
	App[$.FILENAME],
	[[94, 6]]
);

var root = $.add_locations(
	$.from_html(
		`

<main class="min-h-dvh p-[clamp(1rem,3vw,3rem)]" id="main-content">
  <div class="mx-auto max-w-2xl">
    <h1 class="mb-2 text-3xl font-bold text-gray-100">
      Forgejo Instance Index
    </h1>
    <p class="mb-8 text-sm text-gray-400"> </p>

    <div class="mb-8">
      <input type="search" placeholder="Search instances..." class="w-full rounded-lg border border-mauve-800 bg-mauve-900 px-4 py-3 placeholder-gray-500 focus:border-liseran focus:ring-1 focus:ring-liseran focus:outline-none"/>
    </div>

    <!>
  </div>
</main>`,
		1
	),
	App[$.FILENAME],
	[[49, 0, [[50, 2, [[51, 4], [54, 4], [58, 4, [[59, 6]]]]]]]]
);

export default function App($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, App);

	let query = $.tag($.state(""), 'query');
	let results = $.tag($.state($.proxy([])), 'results');
	let loading = $.tag($.state(false), 'loading');
	let error = $.tag($.state(null), 'error');
	let count = $.tag($.state(0), 'count');
	let debounceTimer;

	async function handleSearch() {
		$.set(loading, true);
		$.set(error, null);

		try {
			$.set(results, (await $.track_reactivity_loss(searchInstances($.get(query))))(), true);
		} catch(err) {
			$.set(error, err instanceof Error ? err.message : "Search failed", true);
			$.set(results, [], true);
		} finally {
			$.set(loading, false);
		}
	}

	function onInput() {
		clearTimeout(debounceTimer);

		debounceTimer = setTimeout(
			() => {
				handleSearch();
			},
			300
		);
	}

	$.user_effect(() => {
		getInstanceCount().then((c) => {
			$.set(count, c, true);
		}).catch(() => {
			$.set(count, 0);
		});
	});

	onMount(() => {
		handleSearch();
	});

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root();
	var main = $.sibling($.first_child(fragment));
	var div = $.sibling($.child(main));
	var p = $.sibling($.child(div), 3);
	var text = $.child(p);

	$.reset(p);

	var div_1 = $.sibling(p, 2);
	var input = $.sibling($.child(div_1));

	$.remove_input_defaults(input);
	$.next();
	$.reset(div_1);

	var node = $.sibling(div_1, 2);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root_1();

			$.next(2);
			$.append($$anchor, fragment_1);
		};

		var consequent_1 = ($$anchor) => {
			var fragment_2 = root_2();
			var p_1 = $.sibling($.first_child(fragment_2));
			var text_1 = $.child(p_1, true);

			$.reset(p_1);
			$.next();
			$.template_effect(() => $.set_text(text_1, $.get(error)));
			$.append($$anchor, fragment_2);
		};

		var consequent_3 = ($$anchor) => {
			var fragment_3 = root_3();
			var node_1 = $.sibling($.first_child(fragment_3));

			{
				var consequent_2 = ($$anchor) => {
					var fragment_4 = root_4();

					$.next(2);
					$.append($$anchor, fragment_4);
				};

				var d = $.derived(() => !$.get(query).trim());

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if ($.get(d)) $$render(consequent_2);
					}),
					'if',
					App,
					73,
					6
				);
			}

			var ul = $.sibling(node_1, 2);
			var node_2 = $.sibling($.child(ul));

			$.add_svelte_meta(
				() => $.each(node_2, 17, () => $.get(results), (instance) => instance.id, ($$anchor, instance) => {
					$.next();

					var fragment_5 = root_5();
					var li = $.sibling($.first_child(fragment_5));
					var a = $.sibling($.child(li));
					var text_2 = $.child(a);

					$.reset(a);

					var p_2 = $.sibling(a, 2);
					var text_3 = $.child(p_2, true);

					$.reset(p_2);
					$.next();
					$.reset(li);
					$.next();

					$.template_effect(() => {
						$.set_attribute(a, 'href', $.get(instance).link);

						$.set_text(text_2, `
              ${$.get(instance).name ?? ''}
            `);

						$.set_text(text_3, $.get(instance).description);
					});

					$.append($$anchor, fragment_5);
				}),
				'each',
				App,
				77,
				8
			);

			$.next();
			$.reset(ul);
			$.next();
			$.append($$anchor, fragment_3);
		};

		var consequent_4 = ($$anchor) => {
			var fragment_6 = root_6();

			$.next(2);
			$.append($$anchor, fragment_6);
		};

		var d_1 = $.derived(() => $.get(query).trim());

		var alternate = ($$anchor) => {
			var fragment_7 = root_7();

			$.next(2);
			$.append($$anchor, fragment_7);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(loading)) $$render(consequent); else if ($.get(error)) $$render(consequent_1, 1); else if ($.get(results).length > 0) $$render(consequent_3, 2); else if ($.get(d_1)) $$render(consequent_4, 3); else $$render(alternate, -1);
			}),
			'if',
			App,
			68,
			4
		);
	}

	$.next();
	$.reset(div);
	$.next();
	$.reset(main);

	$.template_effect(() => $.set_text(text, `
      ${$.get(count) ?? ''} instance${$.strict_equals($.get(count), 1) ? '' : 's'} indexed
    `));

	$.delegated('input', input, onInput);

	$.bind_value(
		input,
		function get() {
			return $.get(query);
		},
		function set($$value) {
			$.set(query, $$value);
		}
	);

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['input']);